$(document).ready(function() {
  console.log("cart loaded")
})
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      var d_type=$(this).data('type');
      var d_tag=$(this).data('tag');
      console.log($(this), "CHECK THIS!!!!!")
      d_type = d_type.toString();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      console.log("test");
      
      if(d_type == "jackets" || d_tag == "jacket" || d_tag == "jackets"){
        $.get('/products/garment-bag.js',function(bag){
          $.get('/products/gift-box.js',function(gift){
            console.log("test2", gift.variants[0], bag.variants[0]);
            
            function isVariantInCart(variantId, cart) {
              for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].variant_id === variantId) {
                  return true;
                }
              }
              return false;
            }
            
            // Usage example
            jQuery.getJSON('/cart.js', function(cart) {
              var item1VariantId = bag.variants[0].id;//garment
              var item2VariantId = gift.variants[0].id;//gift
              
              var isItem1InCart = isVariantInCart(item1VariantId, cart);
              var isItem2InCart = isVariantInCart(item2VariantId, cart);
            
              if (isItem1InCart && isItem2InCart) {
                $.post('/cart/change.js',{ quantity: 0, id: bag.variants[0].id },function(update_data2){
                  $.post('/cart/change.js',{ quantity: 0, id: gift.variants[0].id },function(update_data){
                    console.log("test444", update_data2, update_data);
                    var count=0;
                    jQuery.getJSON('/cart.js', function(cart) {
                      $.each(cart.items,function(index,item){
                        console.log("test3", item, item.product_type);
                        if(item.product_type == "Jackets"){
                          var toadd=item.quantity;
                          count=count+toadd;
                        }
                      });
                      console.log("test4", count);
                      $.post('/cart/add.js',{ quantity: count, id: bag.variants[0].id },function(update_data22){
                        $.post('/cart/add.js',{ quantity: count, id: gift.variants[0].id },function(update_data21){
                          window.location.reload();
                        }, 'json');
                      }, 'json');
                    });
    
                  }, 'json');
                }, 'json');
              } else if (isItem1InCart) {
                $.post('/cart/change.js', { quantity: 0, id: bag.variants[0].id }, function(update_data2) {
                  var count = 0;
                  jQuery.getJSON('/cart.js', function(cart) {
                    $.each(cart.items, function(index, item) {
                      if (item.product_type == "Jackets") {
                        var toadd = item.quantity;
                        count += toadd;
                      }
                    });
                    $.post('/cart/add.js', { quantity: count, id: bag.variants[0].id }, function(update_data22) {
                      window.location.reload();
                    }, 'json');
                  });
                }, 'json');
              } else if (isItem2InCart) {
                $.post('/cart/change.js', { quantity: 0, id: gift.variants[0].id }, function(update_data) {
                  var count = 0;
                  jQuery.getJSON('/cart.js', function(cart) {
                    $.each(cart.items, function(index, item) {
                      if (item.product_type == "Jackets") {
                        var toadd = item.quantity;
                        count += toadd;
                      }
                    });
                    $.post('/cart/add.js', { quantity: count, id: gift.variants[0].id }, function(update_data21) {
                      window.location.reload();
                    }, 'json');
                  });
                }, 'json');
              } else {
                console.log("Neither item1 nor item2 are in the cart.");
              }
            });

            // $.post('/cart/change.js',{ quantity: 0, id: bag.variants[0].id },function(update_data2){
            //   $.post('/cart/change.js',{ quantity: 0, id: gift.variants[0].id },function(update_data){
            //     console.log("test444", update_data2, update_data);
            //     var count=0;
            //     jQuery.getJSON('/cart.js', function(cart) {
            //       $.each(cart.items,function(index,item){
            //         console.log("test3", item, item.product_type);
            //         if(item.product_type == "Jackets"){
            //           var toadd=item.quantity;
            //           count=count+toadd;
            //         }
            //       });
            //       console.log("test4", count);
            //       $.post('/cart/add.js',{ quantity: count, id: bag.variants[0].id },function(update_data22){
            //         $.post('/cart/add.js',{ quantity: count, id: gift.variants[0].id },function(update_data21){
            //           window.location.reload();
            //         }, 'json');
            //       }, 'json');
            //     });

            //   }, 'json');
            // }, 'json');




            

          }, 'json');
        }, 'json');
        
      }
      // this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))

      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const cart = JSON.parse(state);
        this.classList.toggle('is-empty', cart.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', cart.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(cart.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, cart.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      })
      .finally(() => {
        // dispatch event to revalidate promoted products
        document.dispatchEvent(new Event('cart:updated'));
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
        '[quantity]',
        document.getElementById(`Quantity-${line}`).value
      );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
$(document).on('click','.cart-item__quantity .quantity__button[name="minus"]', function(){
  var d_type=$(this).data('type');
  d_type = d_type.toString();
  var count=0;
  if(d_type == "jackets"){
    jQuery.getJSON('/cart.js', function(cart) {
      $.each(cart.items,function(index,item){
        if(item.product_type == "Jackets"){
          var toadd=item.quantity;
          count=count+toadd;
        }
      });

      var j_qnty= $(this).closest('.quantity').find('.quantity__input').val();
      $.get('/products/garment-bag.js',function(bag){
        $.get('/products/gift-box.js',function(gift){

          $.post('/cart/change.js',{ quantity: count-1, id: bag.variants[0].id },function(update_data2){
            $.post('/cart/change.js',{ quantity: count-1, id: gift.variants[0].id },function(update_data){
              window.location.reload();
            }, 'json');
          }, 'json');

        }, 'json');
      }, 'json');
    });
  }
});
$(document).on('click','.cart-item__quantity .quantity__button[name="plus"]', function(){
  var d_type=$(this).data('type');
  d_type = d_type.toString();
  var count=0;
  if(d_type == "jackets"){
    jQuery.getJSON('/cart.js', function(cart) {
      $.each(cart.items,function(index,item){
        if(item.product_type == "Jackets"){
          var toadd=item.quantity;
          count=count+toadd;
        }
      });
      var j_qnty= $(this).closest('.quantity').find('.quantity__input').val();
      $.get('/products/garment-bag.js',function(bag){
        $.get('/products/gift-box.js',function(gift){

          $.post('/cart/change.js',{ quantity: count+1, id: bag.variants[0].id },function(update_data2){
            $.post('/cart/change.js',{ quantity: count+1, id: gift.variants[0].id },function(update_data){
              window.location.reload();
            }, 'json');
          }, 'json');

        }, 'json');
      }, 'json');
    });
  }
});
